import { Component } from '@angular/core';

@Component({
    selector: 'bb-layouts-and-navigation-page-ui',
    templateUrl: 'bb-layouts-page-ui.component.html',
    standalone: false,
})
export class BbLayoutsPageUiComponent {
}
